import React, { FC } from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { UploadGuideFigureFiles } from './UploadGuideFigureFiles';
import useKeyDown from '../../../utils/useKeyDown';
import { useFiguresContext } from './FiguresContext';

export const EditGuideFigure: FC<{ isNew: boolean }> = ({ isNew }) => {
  const { closeModal, confirmAndClose } = useFiguresContext();

  useKeyDown('Escape', async () => {
    closeModal();
  });

  return (
    <>
      <DialogTitle>{isNew ? 'Sett inn figur i anvisning' : 'Rediger figur'}</DialogTitle>
      <DialogContent>
        <UploadGuideFigureFiles />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={closeModal}>
          Lukk
        </Button>
        {isNew && (
          <Button variant="contained" onClick={confirmAndClose}>
            Sett inn figur
          </Button>
        )}
      </DialogActions>
    </>
  );
};
